// extracted by mini-css-extract-plugin
export var emotics = "metamorphosis-slider-module--emotics--ibRUb";
export var subtitle = "metamorphosis-slider-module--subtitle--enRoK";
export var title = "metamorphosis-slider-module--title--lO11m";
export var wrapper = "metamorphosis-slider-module--wrapper--tPVS8";